<template>
  <div class="external-iframe" v-html="EventDetail.iframe">
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "ExternalIframe",
  props: {
    iframe: String
  },
  computed: {
    ...mapGetters(['EventDetail'])
  }
}
</script>

<style lang="scss">
  .external-iframe {
    width: 100%;
    aspect-ratio: 16/9;
    & iframe {
      width: 100%;
      height: 100%;
    }
  }
</style>